const styles = ({ BREAKPOINTS }) => ({
  container: {
    margin: '10px auto 100px',
    maxWidth: '1070px',
    paddingBottom: '50px',
    [`@media (min-width: ${BREAKPOINTS.SM})`]: {
      display: 'flex',
      marginTop: '50px'
    }
  },
  main: {
    [`@media (min-width: ${BREAKPOINTS.SM})`]: {
      width: '65%'
    }
  },
  spinner: {
    margin: '100px auto'
  }
})

export default styles
